import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export class ContractByContractor {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  description!: string;
  @IsString()
  @Expose()
  number!: string;
}

export class ContractByContractorResponse extends GenericTableResponse<ContractByContractor> {
  @Type(() => ContractByContractor)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Contract>;
}
